import React from 'react';
import { Sticky } from 'react-stickup';

import { useSession } from '@hooks/useSession';

import {
  TimelineWrapper,
  TimelineContainerRight,
  TimelineContainerLeft,
  TimelineContent,
  Header,
} from './TimelineTree.style';

const TimelineTree: React.FC<{
  /**
   * Text to show on a header before rendering `nodes`. Leave out for no header.
   */
  header?: string;
  /**
   * Collection of child elements to show on the timeline
   */
  nodes: React.ReactNode[];
  style?: React.CSSProperties;
}> = ({ header = '', nodes, style }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const {
    state: { isAuthenticated, isCurator },
  } = useSession();

  return (
    <div ref={ref} style={{ width: '100%' }}>
      {header ? (
        <Sticky
          container={ref}
          defaultOffsetTop={isCurator ? 190 : 100}
          style={{ zIndex: 2 }}
        >
          <Header isSharing={!isAuthenticated}>{header}</Header>
        </Sticky>
      ) : null}
      <TimelineWrapper isSharing={!isAuthenticated} style={style}>
        {nodes.map((node, index) =>
          index % 2 === 0 ? (
            <TimelineContainerLeft
              key={`timeline-tree-leaf-${header}-${index}`}
            >
              <TimelineContent alignRight>{node}</TimelineContent>
            </TimelineContainerLeft>
          ) : (
            <TimelineContainerRight
              key={`timeline-tree-leaf-${header}-${index}`}
            >
              <TimelineContent>{node}</TimelineContent>
            </TimelineContainerRight>
          )
        )}
      </TimelineWrapper>
    </div>
  );
};

export default TimelineTree;
